import React, { useEffect, useRef, useState } from "react";
import Header from "./component/Header";
import { FaCirclePlay } from "react-icons/fa6";
import Cards from "./component/Cards";
import Footer from "./component/Footer";
import Features from "./component/Features";
import Clients from "./component/Clients";
import PricingPlans from "./component/PricingPlans";
import Faqs from "./component/Faqs";
import TechnologiesWeUse from "./component/TechnologiesWeUse";
import { Link } from "react-router-dom";
import { useAnimation, useInView, motion } from "framer-motion";
import { Popup } from "./component/PopupComponent";

const Home = () => {
  const ref = useRef(null);
  const [load, setLoad] = useState(true);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();
  const transition = { duration: 0.8 };
  console.log("Cloud name:", process.env.REACT_APP_CLOUDINARY_CLOUD_NAME);
  console.log("Upload preset:", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView, mainControls]);

  useEffect(() => {
    setLoad(false);
  }, []);
  const fadeInAnimationVarinat = {
    initial: {
      opacity: 0,
      x: -150,
    },
    animate: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.25 * index,
        duration: 0.8,
      },
    }),
  };

  const fadeInAnimationVarinas = {
    initial: {
      opacity: 0,
      x: 150,
    },
    animate: (index) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.25 * index,
        duration: 0.8,
      },
    }),
  };

  useEffect(() => {
    const storedUserData = localStorage.getItem("user");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
    }
  }, []);

  const fadeInAnimationVarinats = {
    initial: {
      opacity: 0,
      y: 150,
    },
    animate: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.25 * index,
        duration: 0.8,
      },
    }),
  };
  return (
    <>
      <Header />
      <Popup />
      <div className="relative bg-gradient-to-r from-black to-logo justify-center items-center text-white">
        <div className="container mx-auto md:flex md:justify-start md:items-start justify-center md:p-0 p-6 items-center border-logo w-[100%]">
          <div className="md:pl-24 md:w-[50%] md:pt-28 pt-6">
            <motion.div
              variants={fadeInAnimationVarinat}
              initial="initial"
              whileInView="animate"
              viewport={{
                once: true,
              }}
              className="text-start"
            >
              <h2 className="md:text-start text-center md:text-xl text-white font-bold">
                AS-TECH COMMUNITY (SMC-PVT) LTD
              </h2>
              <div className="border-t-4 md:mx-0 mx-auto border-orange-400 mt-2 w-20 rounded-full"></div>
            </motion.div>
            {/* <h2 className='text-sm font-bold'></h2> */}
            <motion.div
              variants={fadeInAnimationVarinas}
              initial="initial"
              whileInView="animate"
              viewport={{
                once: true,
              }}
            >
              <h2 className="md:text-5xl text-2xl md:text-start text-center font-bold py-3">
                Empowering Digital Minds to Transform Future!
              </h2>
            </motion.div>
            <motion.div
              variants={fadeInAnimationVarinats}
              initial="initial"
              whileInView="animate"
              viewport={{
                once: true,
              }}
            >
              <h3 className="md:text-start text-sm text-center">
                AS-Tech is a vibrant community of IT professionals,
                entrepreneurs, and freelancers united to drive business success.
                We deliver tailored software development, strategic planning,
                and expert management services to help businesses thrive.
                Through collaborative projects and referrals, we connect
                talented tech professionals with opportunities that matter.
              </h3>
            </motion.div>
            <motion.div
              variants={fadeInAnimationVarinats}
              initial="initial"
              whileInView="animate"
              viewport={{
                once: true,
              }}
              className="py-3 mt-3 md:text-start text-center gap-6 md:flex items-center"
            >
              <Link to="/services">
                <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 text-sm rounded-full font-semibold shadow-lg">
                  View Services
                </button>
              </Link>
            </motion.div>
          </div>
          <div className="md:absolute md:right-16 md:pr-12 pt-3 md:pt-10 md:w-[45%] md:top-6 flex justify-center items-center">
            <img
              src={require("../src/assets/images/main copy-01.png")}
              alt="Main"
              className="z-10 md:w-[100%]"
            />
          </div>
          <div className="large-screen-images absolute md:right-36 top-16 -right-[10%]">
            <img
              src={require("../src/assets/images/dotsimage-removebg-preview.png")}
              alt=""
              className="w-24 h-24"
            />
          </div>
          <div className="large-screen-images md:absolute md:-right-20 md:pr-3 md:w-[55%] flex justify-center items-center">
            <img
              src={require("../src/assets/images/line 1.png")}
              alt="Main"
              className="md:w-[70%]"
            />
          </div>
        </div>
        <div className="absolut bg-transparent bottom-80 z-[1000] h-[10px]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 190">
            <path
              fill="#373AC8"
              fill-opacity="0.7"
              d="M0,128L48,117.3C96,107,192,85,288,80C384,75,480,85,576,122.7C672,160,768,224,864,218.7C960,213,1056,139,1152,96C1248,53,1344,43,1392,37.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
        {/* <div className='absolut bottom-80 z-[1000] h-[10px] opacity-'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 190"><path fill="#373AC880" fill-opacity="0.6" d="M0,160L40,133.3C80,107,160,53,240,42.7C320,32,400,64,480,106.7C560,149,640,203,720,197.3C800,192,880,128,960,106.7C1040,85,1120,107,1200,133.3C1280,160,1360,192,1400,208L1440,224L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg>
                </div> */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 190">
          <path
            fill="#ffff"
            fill-opacity="1"
            d="M0,64L48,85.3C96,107,192,149,288,160C384,171,480,149,576,122.7C672,96,768,64,864,74.7C960,85,1056,139,1152,160C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
      <Cards />
      <div className="mt-20">
        <Features />
      </div>

      <PricingPlans />
      <Clients />
      <TechnologiesWeUse />
      <Faqs />

      <Footer />
    </>
  );
};

export default Home;
